import React from 'react'
import { Dialog, Slide, DialogContent, styled } from '@mui/material'
import { ModalTitleIconed } from 'asterX-UI/Modals'

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    position: 'fixed',
    bottom: 0,
    margin: 0,
    borderRadius: '8px 8px 0 0',
    paddingBottom: 20
  }
}))

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />
})

const BottomDialog = ({ open, onClose, children, title = '', subtitle = '', iconComponent = null }) => {
  return (
    <StyledDialog open={open} onClose={onClose} TransitionComponent={Transition}>
      <ModalTitleIconed onClose={onClose} iconComponent={iconComponent} subtitle={subtitle}>
        {title}
      </ModalTitleIconed>
      <DialogContent>{children}</DialogContent>
    </StyledDialog>
  )
}

export default BottomDialog
